import React, { useState } from 'react';
import { CardComponentProps } from '@/lib/cards';
import { scanInbox, ScanInboxResult } from '@/api/mailbox';

/**
 * Inbox Tools Card
 * Provides quick access to inbox management tools
 */
export const InboxToolsCard: React.FC<CardComponentProps> = ({
  card,
  userContext,
  onError,
}) => {
  const [actionInProgress, setActionInProgress] = useState(false);
  const [scanResult, setScanResult] = useState<ScanInboxResult | null>(null);

  const handleAction = async (action: string) => {
    try {
      setActionInProgress(true);
      setScanResult(null);
      if (action === 'Re-scan inbox') {
        const result = await scanInbox();
        setScanResult(result);
      }
    } catch (err) {
      onError?.(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setActionInProgress(false);
    }
  };

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ marginBottom: '1rem', color: '#666', fontSize: '0.9rem' }}>
        Manage and analyze your inbox with these tools.
      </div>

      <div style={{ display: 'grid', gap: '0.5rem' }}>
        {card.cardActionsList.map((action: string) => (
          <button
            key={action}
            onClick={() => handleAction(action)}
            disabled={actionInProgress}
            style={{
              padding: '0.75rem 1rem',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: actionInProgress ? 'not-allowed' : 'pointer',
              opacity: actionInProgress ? 0.6 : 1,
              fontWeight: 500,
            }}
          >
            {action}
          </button>
        ))}
      </div>

      {scanResult && (
        <div
          style={{
            marginTop: '1rem',
            padding: '0.75rem',
            backgroundColor: '#e7f3ff',
            borderLeft: '4px solid #28a745',
            color: '#155724',
            fontSize: '0.85rem',
          }}
        >
          Queued {scanResult.queued} messages for re-scan (last {scanResult.daysBack} days).
        </div>
      )}
    </div>
  );
};

InboxToolsCard.displayName = 'InboxToolsCard';

export default InboxToolsCard;
